/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TermDto } from '../../models/term-dto';
import { UpdateTermDto } from '../../models/update-term-dto';

export interface TermControllerUpdate$Params {
  type: string;
      body: UpdateTermDto
}

export function termControllerUpdate(http: HttpClient, rootUrl: string, params: TermControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<TermDto>> {
  const rb = new RequestBuilder(rootUrl, termControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('type', params.type, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TermDto>;
    })
  );
}

termControllerUpdate.PATH = '/api/term/{type}';
